import React, { useContext, useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "../../Components/comman/Header";
import MobileHeader from "../../Components/comman/MobileHeader";
import { Tab } from "react-bootstrap";
import Images from "../../Helpers/Images";
import FeaturedData from "../../Helpers//FeaturedDataHome.json";
import { Link } from "react-router-dom";
import Aos from "aos";
import {
  BsFillStopwatchFill,
  BsCheckCircleFill,
  BsExclamationCircleFill,
  BsFillStarFill,
  BsChevronDoubleRight,
} from "react-icons/bs";
import { Auth } from "../../Contexts/AuthContext";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import FeaturedBox from "../../Components/comman/FeaturedBox";
const InfluencerDashboard = () => {
  const { auth } = useContext(Auth);
  const [isLoading, setIsLoading] = useState(false);
  const [campaignStatusData, setCampaignStatusData] = useState("");
  useEffect(() => {
    Aos.init({});
    getCampaignStatus();
  }, []);

  // getting campaign status from api
  const getCampaignStatus = () => {
    let config = {
      url: ApiUrl.campaignStatus,
      method: "GET",
    };

    APIRequest(
      config,
      (res) => {
        console.log("res?.data", res?.data);
        setCampaignStatusData(res?.data);
        setIsLoading(false);
      },
      (err) => {
        console.log("err", err);
        setIsLoading(false);
      }
    );
  };
  return (
    <div className="influencer-dashboard-wrapper">
      <Header />
      <MobileHeader />
      <div className="influencer-dash-inner">
        <Tab.Container activeKey={`dashboard`}>
          <Sidebar />
          <div className="influencer-dashContent-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"dashboard"}>
                <div className="maincontent-wrapper">
                  <div className="inner">
                    <div className="heading-part">
                      <div className="userBox">
                        <h3>
                          Hi,
                          <span>
                            {auth.user?.first_name} {auth.user?.last_name}
                          </span>
                        </h3>
                        <p>
                          Welcome to your Influencer Dashboard. Let's
                          collaborate!
                        </p>
                      </div>
                      {/* <Link to="/walletDetails" className="currencyBoxWrapper"> */}
                      {/* <Link to="/" className="currencyBoxWrapper"> */}
                      <div to="/" className="currencyBoxWrapper">
                        <span className="currencyLabel">
                          Your Wallet Balance
                        </span>

                        <div className="currencyBox">
                          <img
                            src={Images.wallet}
                            alt="wallet icon"
                            className="currencyImg"
                          />
                          <p className="currencyTxt">
                            {auth.user?.wallet_balance}/ $
                          </p>
                        </div>
                      </div>
                      {/* </Link> */}
                    </div>
                    <h3 className="heading-title">Your Campaigns</h3>
                    <div className="your-campaign-wrapper">
                      <div
                        className="card-box box1"
                        data-aos="fade-up"
                        data-aos-duration="1000"
                      >
                        <img src={Images.circle} alt="circle" />
                        <div className="heading">
                          <BsFillStopwatchFill className="icon" />
                          <h6>Pending</h6>
                        </div>
                        <p className="number">
                          {campaignStatusData?.pending_count}
                        </p>
                      </div>
                      <div
                        className="card-box box2"
                        data-aos="fade-down"
                        data-aos-duration="1400"
                      >
                        <img src={Images.circle} alt="circle" />
                        <div className="heading">
                          <BsFillStarFill className="icon" />
                          <h6>Active</h6>
                        </div>
                        <p className="number">
                          {campaignStatusData?.active_count}
                        </p>
                      </div>
                      <div
                        className="card-box box3"
                        data-aos="fade-up"
                        data-aos-duration="1800"
                      >
                        <img src={Images.circle} alt="circle" />
                        <div className="heading">
                          <BsCheckCircleFill className="icon" />
                          <h6>Completed</h6>
                        </div>
                        <p className="number">
                          {campaignStatusData?.completed_count}
                        </p>
                      </div>
                      <div
                        className="card-box box4"
                        data-aos="fade-down"
                        data-aos-duration="2200"
                      >
                        <img src={Images.circle} alt="circle" />
                        <div className="heading">
                          <BsExclamationCircleFill className="icon" />
                          <h6>Cancelled</h6>
                        </div>
                        <p className="number">
                          {campaignStatusData?.canceled_count}
                        </p>
                      </div>
                    </div>
                    <h3 className="heading-title">Featured Collaborations</h3>
                    <div className="featured-main-wrapper">
                      <FeaturedBox />
                      {/* <div className="featured-box-wrapper"> */}

                      {/* {FeaturedData.map((item, i) => (
                          <div
                            className="featured-box"
                            key={i}
                            data-aos="fade-up"
                            data-aos-duration="2200"
                          >
                            <img src={item.img} alt="img" />
                            <div className="content">
                              <div className="heading">
                                <h6 className="product-name">
                                  {item.productName}
                                </h6>
                                <p className="p-title">{item.title}</p>
                              </div>
                              <div className="list-wrapper">
                                <div className="list-name">
                                  <span>Followers</span>
                                  <span className="title">
                                    {item.follower}+
                                  </span>
                                </div>
                                <div className="list-name">
                                  <span>Engagement</span>
                                  <span className="title">
                                    {item.engagement}+
                                  </span>
                                </div>
                                <div className="list-name">
                                  <span>Age</span>
                                  <span className="title">{item.age}+</span>
                                </div>
                                <div className="list-name">
                                  <span>Residence</span>
                                  <span className="title">{item.follower}</span>
                                </div>
                              </div>
                              <Link to="/campagin-detail">
                                <button className="niche-btn">niche</button>
                              </Link>
                            </div>
                          </div>
                        ))} */}
                      {/* </div> */}
                      {/* <Link to="/collaboration-hub" className="see-more-btn">
                        See More <BsChevronDoubleRight />
                      </Link> */}
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
      {/* <MainContent/> */}
    </div>
  );
};

export default InfluencerDashboard;
